import { ReactNode } from 'react';

export default function AlternatingRow({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="flex flex-col w-full odd:bg-lightBackground border-tableBackground">
      {children}
    </div>
  );
}
